<ui-section>
  <ui-block>
    <ui-panel
      width="fill"
      class="platform-access-admin"
      panelTitle="Roles & Permissions"
      title="Roles & Permissions"
      [subtitle]="pagePanelSubtitle"
    >
      <div class="catalog-management-grid">
        <ui-panel width="fill" panelTitle="Roles" title="Roles">
          <ui-grid
            width="fill"
            class="catalog-panel"
            [dsConfig]="roleCatalogGridConfig"
            [panelHeaderConfig]="roleCatalogPanelHeaderConfig"
            [showPanelHeader]="true"
          ></ui-grid>
        </ui-panel>

        <ui-panel width="fill" panelTitle="Permissions" title="Permissions">
          <ui-grid
            width="fill"
            class="catalog-panel"
            [dsConfig]="permissionCatalogGridConfig"
            [panelHeaderConfig]="permissionCatalogPanelHeaderConfig"
            [showPanelHeader]="true"
          ></ui-grid>
        </ui-panel>
      </div>
    </ui-panel>
  </ui-block>
</ui-section>
